import { createAction } from "typesafe-actions";

export const requestFullScreen = createAction("fullscreen/REQUEST");
